<template>
<div>
  <div class="user-api-choice-container body">
    <h4 v-if="title !== undefined && title !== null" class="title">
      {{title}}
    </h4>
    <p v-if="!!caption" class="caption">{{caption}}</p>
    <div class="choice-container">
      <div class="choice-box-wrapper" v-for="choice in choices" v-bind:key="choice.index">
        <div class="choice-box" @click="resolve(choice)">
          <h5 v-if="('name' in choice) && choice.name !== null && choice.name !== ''" class="title">
            {{choice.name}}
          </h5>
          <h5 v-else class="title">
            {{$t('errors.api_error_modal.no_name')}}
          </h5>
          <div class="choice-info">
            <ul>
              <li v-for="attribute in listItems" v-bind:key="attribute">
                <p class="caption list-item" v-if="choice[attribute]">
                  {{choice[attribute]}}
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
/*
  This modal appears if the API has run into a submodel problem that it can't intelligently solve by itself
  so user input is needed.
*/
export default {
  props: {
    error: Object,
    includeCtaButton: Boolean,
    ctaButtonText: String,
    listItems: Array,
    title: String,
    caption: String,
    choice: {
      selected: false,
      choiceBoxClass: []
    }
  },
  data() {
    return {
      buttonClasses: [],
      selected: false,
    }
  },
  computed: {
    choices() {
      if (this.error.meta_data) {
        return this.error.meta_data
      } else {
        return {}
      }
    },
  },
  methods: {
    resolve(choice) {
      // Resolve chosen item to parent
      this.buttonClasses.push('is-loading')
      this.$emit('resolve', false, choice)
    },
    resolveCta() {
      this.$emit('resolve', true, {})
    }
  }
}
</script>

<style lang="sass" scoped>
.modal-box
  padding: 0px !important
  position: relative

ul
  list-style-type: none
  text-emphasis: left
  padding: 0
  text-align: left
  padding: 0
  color: #3d4043

.list-item
  margin-bottom: 0

.title
  font-weight: $font-medium
  margin-top: 0
  margin-bottom: 10px

h3
  margin-bottom: 15px

h5
  margin-bottom: 15px
  text-align: left

.footer
  height: 60px
  width: 100%
  margin: 0 auto
  display: flex
  justify-content: space-between
  align-items: center
  border-radius: 4px
  padding-bottom: 1em
  padding-right: 1em
  padding-left: 1em

.choice-info
  ul
    margin: 0

.button
  background: #D6EBCB
  margin-top: 6px
  border: 1px solid rgba(0, 0, 0, 0.05)
  border-radius: 3px
  height: 24px
  cursor: pointer
  user-select: none
  outline: none

.user-api-choice-container
  display: flex
  flex-direction: column
  flex-wrap: wrap

.caption
  max-width: 400px
  font-size: 1.1em
  font-weight: $font-medium
  line-height: 24px

.choice-container
  display: flex
  flex-direction: row
  flex-wrap: wrap
  max-width: 410px
  min-height: 150px
  max-height: 280px
  overflow-y: scroll

.choice-container::-webkit-scrollbar
  -webkit-appearance: none

.choice-container::-webkit-scrollbar:vertical
    width: 10px

.choice-container::-webkit-scrollbar-thumb
    border-radius: 15px
    border: 2px solid white
    background-color: rgba(0, 0, 0, .3)

.cancel
  color: #007AFF
  float: left
  font-size: 16px
  margin-top: 30px

.choice-box-wrapper
  margin: 5px 0

.btn
  margin-top: 20px

.pull-right
  float: right
  min-height: 30px

.choice-box
  cursor: pointer
  padding: 20px
  margin: 0px
  color: #23282d
  width: 400px
  min-height: 100%
  transition: .4s all ease-in-out
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  background: #eff0f1
  text-align: center
  box-shadow: 0 0 9px 0 rgba(189, 189, 189, 0.18)
  border-radius: 3px
  display: block
  user-select: none

.choice-box-selected
  outline: #2488F7 solid 2px
  border-radius: 3px
</style>



// WEBPACK FOOTER //
// UserApiChoice.vue?ba0a92ee